import type { PublisherDetailOut } from '@/api/generated/schemas';

export interface StructureRow {
  /** Plain id — a record appears at most once in this card. */
  key: string;
  id: number;
  name: string;
  isSelf: boolean;
  /** Rendered indented under the row above. */
  isChild: boolean;
}

type StructureSource = Pick<
  PublisherDetailOut,
  'id' | 'name' | 'parent_id' | 'parent' | 'imprints'
>;

/**
 * Publisher: self → its imprints. Imprint: parent → self.
 * An imprint whose `parent` ref is missing renders self-only —
 * the hero stat cell still carries the parent link by id.
 */
export const structureRows = (record: StructureSource): StructureRow[] => {
  const self: StructureRow = {
    key: String(record.id),
    id: record.id,
    name: record.name,
    isSelf: true,
    isChild: false,
  };

  if (record.parent_id == null) {
    return [
      self,
      ...(record.imprints ?? []).map((imprint) => ({
        key: String(imprint.id),
        id: imprint.id,
        name: imprint.name,
        isSelf: false,
        isChild: true,
      })),
    ];
  }

  if (record.parent == null) return [self];

  return [
    {
      key: String(record.parent.id),
      id: record.parent.id,
      name: record.parent.name,
      isSelf: false,
      isChild: false,
    },
    { ...self, isChild: true },
  ];
};
